<template>
  <div class="form-notch">
    <div class="form-notch-leading"></div>
    <div class="form-notch-middle"></div>
    <div class="form-notch-trailing"></div>
  </div>
</template>

<script>
export default {
  name: 'FormNotch'
}
</script>

<style scoped>

</style>
